import React, { createRef, useEffect, useRef, useState } from "react";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { LoadingButton } from "@mui/lab";
import ClearIcon from "@mui/icons-material/Clear";
import {
  FormControlLabel,
  IconButton,
  Checkbox,
  CardContent,
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  FormControl,
  InputLabel,
  Grid,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TableHead,
  Select,
  MenuItem,
  Breadcrumbs,
  Link,
  Container,
  useTheme
} from "@mui/material";
import Page from "src/components/Page";
import DashboardBreadcrumbLink from 'src/components/DashboardBreadcrumbLink';
import { getCamerasList, getClientList } from "src/api/analytics";
import Scrollbar from "src/components/Scrollbar";

import {
  getClientInfo,
  setSaveProtocol,
  getProtocolInfoActions,
  deleteMessage,
  setMultiDevicesProtocol,
  setProtocolsInfoMessages,
  addUpdateIntrusion,
  UpdateMessage,
  getClientProtocolsInfoActions,
  addClientProtocolActions,
  DeleteDeviceMapping,
} from "src/api/protocol";
import {  getClientCameras } from 'src/api/clientDetails';

import CloseIcon from "@mui/icons-material/Close";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { getClientGroupInfo, InsertUpdateEscStatus } from "src/api/liveCameras";
import { Tooltip as MuiTooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { jsonToParam } from "src/utils/config";
import { getAppStorageItem } from 'src/utils/storageProxy';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const protoIcon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const protoCheckedIcon = <CheckBoxIcon fontSize="small" />;

const getAssignedLocationsFromStorage = () => {
  try {
    const assignedLocationsRaw = getAppStorageItem('assigned_locations');
    if (!assignedLocationsRaw) return [];

    const parsedAssignedLocations = JSON.parse(assignedLocationsRaw);
    const assignedLocations = Array.isArray(parsedAssignedLocations)
      ? parsedAssignedLocations
      : [];

    return assignedLocations
      .map((locationItem) => ({
        ID: Number(locationItem?.ID ?? locationItem?.id ?? 0),
        Location: String(locationItem?.Location || locationItem?.name || '').trim(),
      }))
      .filter((locationItem) => locationItem.ID > 0);
  } catch (error) {
    console.error('Failed to read assigned_locations from storage:', error);
    return [];
  }
};

const ProtocolIndividualAll = () => {
  console.log('protocols')
  const theme = useTheme();
  const [escStatus, setEscStatus] = useState(true);
  const [assignedProtocols, setAssignedProtocols] = useState([]);
  const [setClient, setSelectedClient] = useState([]);
  const [setTypeClient, setSelectedTypeClient] = useState([]);
  let client_id = 0;
  if(localStorage.getItem('Type') === 'merge'){
    client_id = localStorage.getItem('ID');
  }
  else{
    client_id = localStorage.getItem('client_id');
  }
  const [clientName, selectedClientName] = useState(null);
  const [cameraList, setCameras] = useState([]);
  const [selectedCamesList, setCamsList] = useState([]);
  const [selectedCamItems, setCamSelectedItems] = useState([]);

  const [protocolList, setProtocols] = useState([]);
  const [open, setOpen] = useState(false);
  const [newProtocolname, setNewProtoName] = useState("");
  const [selectedProto, setSelectedProtocol] = useState([]);


  const [clientInfo, setClientDetails] = useState([]);
  const [showClientInfo, setShowClientInfo] = useState(false);
  const [showProtocolsError, setShowProtocolsError] = useState(false);

  // Form Fields

  ////console.log("selected Cam Items",selectedCamItems);

  // police Number
  const [policeno, setPoliceNo] = useState("");

  //mobile number
  const [mobileno, setMobileNo] = useState("");

  //emil Change

  const [email, setEmail] = useState("");

  //Fire Number
  const [fireNo, setFireNo] = useState("");

  // address
  const [address, setAddress] = useState("");

  // Client ID mandatory
  const [isClientSelected, setIsClientSelected] = useState(false); // State variable to track client selection
  const [saveError, setSaveError] = useState(false); // State to track save error

  // Add new protocol Error
  const [protocolNameError, setProtocolNameError] = useState(false);

  // protocol Messages
  const [data, setData] = useState([]);
  const [introsionMessages, setIntrosionMessages] = useState([]);

  const [messages, setMessages] = useState([]);

  const [message1, setMessage1] = useState("");
  const [message2, setMessage2] = useState("");
  const [message3, setMessage3] = useState("");

  const [errorCams, setErrorCams] = useState("");
  const [openError, setOpenError] = useState(false);

  const [list, setList] = useState([]);
  const [header, setHeader] = useState("");

  const [deviceHist, setDeviceHist] = useState({});

  const [showConfirm, setShowConfirm] = useState(false);

  const [protocolError, setProtocolError] = useState("");

  const [policenoTextFields, setPolicenoTextFields] = useState(1);

  const [activeCameras, setActiveCameras] = useState([]);

  const [inputValue, setInputValue] = useState([]);
  const [checkValue, setCheckValue] = useState(false);

  const [checkProtoValue, setCheckProtoValue] = useState(false);
  const [activeProto, setActiveProto] = useState([]);

  const [assignProtocol, setAssignProtocol] = useState(false);
  const [addProtocol, setAddProtocol] = useState(false);

  const [addMessage, setAddMessage] = useState(false);

  const [isGroupExist, setIsGroupExist] = useState(false);

  const [groupList, setGroupList] = useState([]);

  const [removeData, setRemoveData] = useState([]);
  const [delProto, setDelProto] = useState(false);

  const [displayedData, setDisplyedData] = useState([]);

  const [intrusionTypeError, setIntrusionTypeError] = useState(false);
  const [incidentTypeError, setIncidentTypeError] = useState(false);
  const [message1Error, setMessage1Error] = useState(false);

  const [originalDataNew, setOriginalDataNew] = useState([]);
  const [isProtocolSaveFieldsVisible, setIsProtocolSaveFieldsVisible] = useState(false);

  const storedProperty = localStorage.getItem('Location');
  const AssignClient = localStorage.getItem('AssignClient');

  const [property, setProperty] = useState(() => {
    const stored = localStorage.getItem('selectedProperty');
    return stored ? parseInt(stored) : null;
  });
  const [properties, setProperties] = useState([]);

  const handleCloseError = () => {
    setOpenError(false);
  };

  const [deviceDataExist, setDeviceDataExist] = useState(false);
  const [groupCamerasInfo, setGroupCamersInfo] = useState([]);

  const [messageErrors, setMessageErrors] = useState({});

  const [showMessage, setShowMessage] = useState(false);

  const [addNewProtocolMessageShow, setAddNewProtocolMessageShow] = useState(false);

  useEffect(() => {
    if(AssignClient!=='' && storedProperty!=='') {
      const assignedLocations = getAssignedLocationsFromStorage();
      setProperties(assignedLocations);

      const stored = localStorage.getItem('selectedProperty');
      if (stored) {
        const found = assignedLocations.find((loc) => loc.ID === parseInt(stored));
        if (found) {
          setProperty(found.ID);
        }
      } else {
        const first = assignedLocations[0];
        if (first) {
          setProperty(first.ID);
          localStorage.setItem('selectedProperty', first.ID);
        }
      }
    }
  },[])

  const handlePoliceNoChange = (event) => {
    setPoliceNo(event.target.value);
  };

  const handleMobileChange = (event) => {
    setMobileNo(event.target.value);
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleFireChange = (event) => {
    setFireNo(event.target.value);
  };

  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };

  const HandleProtocolInfo = () => {
    const protocolParams = {
      mapped_action_id: 0
    };

    getClientProtocolsInfoActions(protocolParams, (response) => {
      if (response.status === 200) {
        const protocolsInfo = trimProtocolData(response.data)
        setAssignedProtocols(protocolsInfo)
      }
    })
  }

  const trimProtocolData = (protocolsData) => {
    const trimmedProtocolsData = Array.isArray(protocolsData)
      ? protocolsData.map(item => {
        if (typeof item === 'object' && item !== null) {
          const trimmedItem = {};
          Object.keys(item).forEach(key => {
            trimmedItem[key] =
              typeof item[key] === 'string' ? item[key].trim() : item[key];
          });
          return trimmedItem;
        }
        return item;
      })
      : protocolsData;
    return trimmedProtocolsData;
  }

  const getCamerasList = () =>{
    let bodyParams = {status:'0,1'}
    if (property !== null) {
      bodyParams.property_id = Number(property);
    } else {
      bodyParams.clientid = client_id;
    }

    bodyParams = jsonToParam(bodyParams);

    getClientCameras(bodyParams, (response) => {
      if (response.status === 200) {
        if (response.data !== null) {
          setCameras(response.data);
        } 
      }
    });
  }

  useEffect (()=>{
    getCamerasList();
    getAllClientsList();
  },[property])

  const getAllClientsList = () => {
    getClientList((response) => {
      if (response.status === 200) {
        setSelectedClient(response.data);
        const assignedClient = (property !== null) ? property : client_id;

        const usClients = response.data.filter(
          (row) => String(row.ID) === String(assignedClient)
        );
        const sortedData = [...usClients].sort((a, b) =>
          a.displayname.trim().localeCompare(b.displayname.trim())
        );
        console.log("seorted date ", sortedData);
        setSelectedTypeClient(sortedData);
        if (sortedData.length === 1) {
          selectedClientName(sortedData[0]);
          handleClient(null, sortedData[0]);
        }
        // selectedClientName(sortedData[0]);
        // selectedClientName()
        // console.log("data",usClients);
      }
    });
  }

  useEffect(() => {
 

    // getCamerasList((response) => {
    //   if (response.status === 200) {
    //     setCameras(response.data);
    //   }
    // });

    const escStatus = localStorage.getItem('EscalationStatus');

    if (escStatus === 0) {
      setEscStatus(false)
    } else if (escStatus === 1) {
      setEscStatus(true)
    }

  }, []);

  const updateEscalationStatus = (value) => {
    const escValue = (value) ? 1 : 0;
    let body = { ClientId: parseInt(client_id, 10), EscalationStatus: escValue, Type: 'vidisky' }
    InsertUpdateEscStatus(body, (response) => {
      //console.log(response.data);
      localStorage.setItem('EscalationStatus', escValue)
      setEscStatus(value)
    })
  }

  useEffect(() => {
    const usClients = setClient.filter((row) => row.ClientType === "US");
    const sortedData = [...usClients].sort((a, b) =>
      a.displayname.trim().localeCompare(b.displayname.trim())
    );
    setSelectedTypeClient(sortedData);
  }, []);

  const [clientAvail, setClientAvail] = useState(false);
  useEffect(() => {
    let matchedCameras = [];

    if (clientName && clientName.ID) {
        const assignedClientId = (property !== null) ? Number(property) : Number(clientName.ID)
        let body = { groupId: 0, clientId: assignedClientId };

        getClientGroupInfo(body, (response) => {
          if (response.status === 200) {
            if (response.data.length > 0) {
              setIsGroupExist(true);
              const groupData = response.data;
              console.log('uniqueResult:',JSON.stringify(groupData));

              setGroupCamersInfo(groupData);
              const uniqueResult = Array.from(
                new Map(
                  groupData.map((item) => [
                    `${item.GroupId}-${item.GroupName}`,
                    item,
                  ])
                ).values()
              ).map((item) => ({
                GroupId: item.GroupId,
                GroupName: item.GroupName,
              }));
              setGroupList(uniqueResult);

              console.log('uniqueResult:',JSON.stringify(uniqueResult));

             
              
              // Load cameras for groups
              if (uniqueResult.length > 0) {
                handleGroupChange(null, uniqueResult[0]);

                matchedCameras = cameraList.filter(
                  (camera) =>
                    camera.clientid === clientName.ID &&
                    uniqueResult.some(group => camera.GroupId === group.GroupId)
                );

                console.log('matchedCameras:',JSON.stringify(matchedCameras));
                setCamsList(matchedCameras);

                // If there are cameras, auto-select them
                if (matchedCameras.length > 0) {
                  console.log('cameras selection5');
                  setActiveCameras(matchedCameras.map((cam) => cam.deviceid));
                  setShowProtocolsError(false);
                } else {
                    // Don't set error here - wait for deviceDataExist check
                    setActiveCameras([]);
                }
              }
            } else {
              setIsGroupExist(false);
              setGroupList([]);
              // Load cameras directly when no groups exist
              matchedCameras = cameraList.filter(
                (camera) => camera.clientid === clientName.ID
              );
              setCamsList(matchedCameras);

              // If there are cameras, auto-select them
              if (matchedCameras.length > 0) {
                console.log('cameras selection5');
                setActiveCameras(matchedCameras.map((cam) => cam.deviceid));
                setShowProtocolsError(false);
              } else {
                // Don't set error here - wait for deviceDataExist check
                setActiveCameras([]);
              }
            }
          }
        });
    }

    if (clientName && clientName.ID !== undefined && clientName.ID !== null) {
      const assignedClientId = (property !== null) ? Number(property) : Number(clientName.ID)
      
      getClientInfo(assignedClientId, (response) => {
        if (response.status === 200) {
          setClientDetails(response.data);
        }
      });
    } else {
      setClientDetails([]);
    }
  }, [clientName, cameraList, property]); // Add cameraList to dependencies

  // useEffect(() => {
  //   // console.log("===============================",clientName.ID);
  //   let matchedCameras = [];

  //   // getCamerasList((response) => {
  //   //   if (response.status === 200) {
  //   //     setCameras(response.data)
  //   //   }
  //   // })

  //   //let clientId = value.ID
  //   //let groups = groupInfo.filter(item => item.client_id === cleintId)

  //   if(clientName && clientName.ID){
  //     //setClientAvail(true)
  //     let body = {groupId:0,clientId:clientName.ID}

  //     getClientGroupInfo(body,(response)=>{

  //       if(response.status === 200){

  //         if(response.data.length>0){
  //           setIsGroupExist(true)
  //           setGroupCamersInfo(response.data)
  //           const uniqueResult = Array.from(
  //             new Map(response.data.map(item => [`${item.GroupId}-${item.GroupName}`, item])).values()
  //             ).map(item => ({
  //                 GroupId: item.GroupId,
  //                 GroupName: item.GroupName
  //             }));
  //           setGroupList(uniqueResult)
  //         }
  //         else{
  //           setIsGroupExist(false)
  //           setGroupList([])

  //           // console.log("=================cameraList======================",cameraList);

  //           matchedCameras = cameraList.filter(camera => camera.clientid === clientName.ID);
  //           setCamsList(matchedCameras)
  //         }
  //       }
  //     })
  //   }

  //   else{
  //     //setClientAvail(false)
  //   }

  //   // if(!isGroupExist){
  //   //   matchedCameras = cameraList.filter(camera => camera.clientid === clientName.ID);
  //   //   setCamsList(matchedCameras)
  //   // }

  //   if(clientName && clientName.ID!==undefined && clientName.ID!==null){
  //   getClientInfo(clientName.ID,(response) => {
  //     if (response.status === 200) {
  //       setClientDetails(response.data);
  //     }
  //   })
  // }
  // else{
  //   setClientDetails([])
  // }
  // },[clientName])

  useEffect(() => {
    // console.log('clientAvail',clientAvail);
    // console.log('protocol List',protocolList);
  }, [clientAvail]);

  const jsonToFormData = (data) => {
    let formdata = new FormData();
    for (let x in data) formdata.append(x, data[x]);
    return formdata;
  };

  useEffect(() => {
    if (data.length > 0) {
      const displayedData = data;
      setDisplyedData(displayedData);
    } else {
      setDisplyedData([]);
    }
  }, [data]);

  let listHist = [];



  useEffect(() => {
    clientProtocolListing();
  }, [activeCameras, activeProto])

  const clientProtocolListing = () => {
    let params = {}

    if (activeProto.length > 0 && activeCameras.length === 0) {
      console.log('condition1');
      params = {
        device_id: [],
        intrusion_id: activeProto.join(',')
      };

      ////console.log(protocolList)

      if (protocolList.length > 0) {

        const IntrusionInfo = protocolList.filter(item => activeProto.includes(item.Id))
        if (IntrusionInfo.length > 0) {
          setAssignedProtocols(IntrusionInfo)
          return;
        }
      }

    }
    else if (activeCameras.length > 0 && activeProto.length > 0) {
      console.log('condition2');
      //let deviceIds = selectedCamItems.map(item => item.deviceid);

      params = {
        device_id: activeCameras,
        intrusion_id: activeProto.join(',')
      };

    }
    else if (activeCameras.length > 0 && activeProto.length === 0) {
      console.log('condition3');
      //  let deviceIds = selectedCamItems.map(item => item.deviceid);

      params = {
        device_id: activeCameras,
        intrusion_id: 0
      };
    }

    if (Object.keys(params).length) {

      const protocolParams = {
        mapped_action_id: 0
      };

      getClientProtocolsInfoActions(protocolParams, (response) => {
        console.log('activeProto:', JSON.stringify(activeProto))
        console.log('deviceId:', JSON.stringify(params.device_id))
        if (response.status === 200) {
          if (response.data.length > 0) {
            const protocolsData = trimProtocolData(response.data)
            console.log('device_ids:', params.device_id);
            // filter with params device_id in protocolsData
            // If params.device_id is defined and non-empty, filter protocolsData entries to only those whose device_id is in params.device_id

            let filteredProtocolsData = protocolsData;
            //console.log('filteredProtocolsData:', JSON.stringify(filteredProtocolsData))
            if (
              params &&
              params.device_id &&
              Array.isArray(params.device_id) &&
              params.device_id.length > 0
            ) {
              // some objects may use a different field, ensure protocolsData objects have device_id property
              filteredProtocolsData = protocolsData.filter((item) =>
                params.device_id.includes(item.DeviceId)
              );
            }


            console.log('filterProtocolsDataCount length:', filteredProtocolsData.length)
            if (filteredProtocolsData.length > 0) {
              // Also filter through params.intrusion_id if it's set/nonzero.
              let filteredAndIntrusionFiltered = filteredProtocolsData;

              if (
                params &&
                activeProto &&
                Array.isArray(activeProto) &&
                activeProto.length > 0
              ) {
                // some objects may use a different field, ensure protocolsData objects have device_id property
                filteredAndIntrusionFiltered = filteredProtocolsData.filter((item) =>
                  activeProto.includes(item.DetectionTypeId)
                );
              }

              console.log('filteredAndIntrusionFiltered length:', filteredAndIntrusionFiltered.length)
              if (filteredAndIntrusionFiltered.length > 0) {
                console.log('data exists:', true)
                setAssignedProtocols(filteredAndIntrusionFiltered)
                setDeviceDataExist(true)
              } else {
                console.log('data exists1:', false)
                protocolsListing();
              }

            } else {
              console.log('data exists2:', false)
              protocolsListing();
            }
          }
          else {
            console.log('data exists3:', false)
            protocolsListing();
          }
        }
      })
    }
  }

  const protocolsListing = () => {
    setAssignedProtocols([])
    setDeviceDataExist(false);
    
    if (activeProto.length > 0) {
      if (protocolList.length > 0) {
        const IntrusionInfo = protocolList.filter(item => activeProto.includes(item.Id))
        if (IntrusionInfo.length > 0) {
          setAssignedProtocols(IntrusionInfo)
          console.log('IntrusionInfo :', JSON.stringify(IntrusionInfo))
          setShowProtocolsError(false);
          return
        }
      }
    }
    
    // Only show error if we have cameras but no protocols
    if (activeCameras.length > 0) {
      setShowProtocolsError(true);
    } else {
      setShowProtocolsError(false);
    }
  }
  // useEffect(() => {
  //     console.log(introsionMessages)
  //       if(introsionMessages.length === 0){
  //         setMessage1('');
  //         setMessage2('');
  //         setMessage3('');
  //       }
  //       else{
  //         if(introsionMessages.length=== 1 && !deviceDataExist){
  //                 setMessage1(introsionMessages[0].Message1?introsionMessages[0].Message1:introsionMessages[0]);
  //                 setMessage2(introsionMessages[0].Message2?introsionMessages[0].Message2:introsionMessages[1]);
  //                 setMessage3(introsionMessages[0].Message3?introsionMessages[0].Message3:introsionMessages[2]);
  //         }
  //         else if(introsionMessages.length > 1 && !deviceDataExist){
  //           introsionMessages[0] ? setMessage1(introsionMessages[0]) : setMessage1('')
  //           introsionMessages[1] ? setMessage2(introsionMessages[1]) : setMessage2('')
  //           introsionMessages[2] ? setMessage3(introsionMessages[2]) : setMessage3('')
  //         }
  //      }
  //   },[introsionMessages])

  useEffect(() => {
    if (introsionMessages.length > 0) {
      // console.log('introsionMessages',introsionMessages)
      setMessages(introsionMessages);
    } else {
      setMessages([]);
    }
  }, [introsionMessages]);

  // Effect to manage showProtocolsError based on deviceDataExist and activeCameras
  useEffect(() => {
    // Only show error if device data doesn't exist AND we have cameras
    if (!deviceDataExist && activeCameras.length > 0) {
      // Check if we should wait or show error immediately
      // This prevents premature error display
      if (activeProto.length > 0 || protocolList.length > 0) {
        // Still loading, don't show error yet
        setShowProtocolsError(false);
      } else {
        // No protocols available, show error
        setShowProtocolsError(true);
      }
    } else if (deviceDataExist) {
      // Data exists, no error
      setShowProtocolsError(false);
    }
  }, [deviceDataExist, activeCameras.length, activeProto.length, protocolList.length]);

  useEffect(() => {

    if (clientInfo.length == 1) {
      ////console.log("clientInfo Length" ,clientInfo)
      if (clientInfo[0].PoliceNo !== null) {
        setPoliceNo(clientInfo[0].PoliceNo);
      } else {
        setPoliceNo("");
      }

      if (clientInfo[0].MobileNo !== null) {
        setMobileNo(clientInfo[0].MobileNo);
      } else {
        setMobileNo("");
      }
      // setAddress(clientInfo[0].Address)
      if (clientInfo[0].FireNo !== null) {
        setFireNo(clientInfo[0].FireNo);
      } else {
        setFireNo("");
      }

      if (clientInfo[0].Email !== null) {
        setEmail(clientInfo[0].Email);
      } else {
        setEmail("");
      }
      if (clientInfo[0].Address !== null) {
        setAddress(clientInfo[0].Address);
      } else {
        setAddress("");
      }
    } else {
      // setFianlClientData([]);

      setPoliceNo("");
      setMobileNo("");
      setAddress("");
      setFireNo("");
      setEmail("");
      setInputValue("");
    }
  }, [clientInfo]);

  //const [clientSelected,setClientSelected]=useState(false)
  // const handleClient = (_, value) => {
  //   console.log("===============================client dropdown==============",value);
  //   setActiveCameras([])
  //   setCheckValue(false)
  //   setGroupCamersInfo([])
  //   setActiveProto([])
  //   setCheckProtoValue(false)

  //   if (!value) {
  //     setIsGroupExist(false)
  //     selectedClientName([]);
  //     setCamSelectedItems([]);
  //     setCamsList([]);
  //     setPoliceNo('')
  //     setMobileNo('')
  //     setAddress('')
  //     setFireNo('')
  //     setEmail('')
  //     setIsClientSelected(false);
  //     setSaveError(false);
  //     setClientGroups([])
  //     setSelectedProtocol([]);
  //     setGroupList([])
  //     //setSelectedProto([]);
  //     //setList([])
  //   } else {
  //     //setList([])

  //     setDeviceDataExist(false);
  //     setCamSelectedItems([]);
  //     selectedClientName(value);
  //     setIsClientSelected(true);
  //     setLastEmail(false)
  //     setLastFireNumber(false)
  //     setLastNumber(false)
  //     setLastContact(false)
  //     setSelectedProtocol([]);
  //     setGroupList([])
  //     setCamsList([])
  //     // if(groups.length>0){
  //     //   setIsGroupExist(true)
  //     //   setGroupList(groups)
  //     // }
  //     // else{
  //     //   setIsGroupExist(false)
  //     //   setGroupList([])
  //     // }

  //     //console.log(groups)

  //   }
  // };

  const handleClient = (_, value) => {
    console.log("Client dropdown changed", value);

    // Reset camera-related states
    setActiveCameras([]);
    setCheckValue(false);
    setGroupCamersInfo([]);
    setActiveProto([]);
    setCheckProtoValue(false);

    if (!value) {
      // Clear all client-related states
      setIsGroupExist(false);
      selectedClientName(null);
      setCamSelectedItems([]);
      setCamsList([]);
      setPoliceNo("");
      setMobileNo("");
      setAddress("");
      setFireNo("");
      setEmail("");
      setIsClientSelected(false);
      setSaveError(false);
      setSelectedProtocol([]);
      setGroupList([]);
    } else {
      // Set new client and prepare for camera loading
      setDeviceDataExist(false);
      setCamSelectedItems([]);
      selectedClientName(value);
      setIsClientSelected(true);
      setLastEmail(false);
      setLastFireNumber(false);
      setLastNumber(false);
      setLastContact(false);
      setSelectedProtocol([]);
      setGroupList([]);
      setCamsList([]);

      // Force a re-render to trigger camera loading
      setClientAvail((prev) => !prev);
    }
  };

  const [openAuto, setOpenAuto] = useState(false);

  const handleCamera = (event, value) => {
    let actCams = [];
    if (value.some((obj) => obj.hasOwnProperty("selectall"))) {
      if (activeCameras.length === selectedCamesList.length) {
        setActiveCameras([]);
        setCheckValue(false);
      } else {
        selectedCamesList.forEach((item) => {
          actCams.push(item.deviceid);
        });
        console.log('cameras selection1');
        setActiveCameras(actCams);
        setCheckValue(true);
      }
    } else {
      let id = value[0].deviceid;
      if (activeCameras.includes(id)) {
        let filterArr = activeCameras.filter((divid) => divid !== id);

        if (filterArr.length === 0) {
          setIntrosionMessages([]); // updated on 2024-10-29
        }
        console.log('cameras selection2');
        setActiveCameras(filterArr);
        if (checkValue) {
          setCheckValue(false);
        }
      } else {
        console.log('cameras selection3');
        setActiveCameras((prv) => [...prv, id]);
      }
    }
  };

  useEffect(() => {
    if (
      activeCameras.length === selectedCamesList.length &&
      activeCameras.length > 0
    ) {
      setCheckValue(true);
    }

    if (activeCameras.length > 0) {
      setClientAvail(true);
    } else {
      setClientAvail(false);
    }
  }, [activeCameras]);

  const handleOpen = () => {
    setIsExisted(false);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setNewProtoName("");
    setProtocolNameError(false);
  };

  const [isExisted, setIsExisted] = useState(false);

  useEffect(() => {
    setMessageErrors({});
    if (activeProto.length === protocolList.length && activeProto.length > 0) {
      setCheckProtoValue(true);
    }
  }, [activeProto]);

  const handleProtocol = (event, value) => {
    let actProto = [];
    if (value.some((obj) => obj.hasOwnProperty("selectall"))) {
      if (activeProto.length === protocolList.length) {
        setActiveProto([]);
        setCheckProtoValue(false);
        setSelectedProtocol([]);
        setIntrosionMessages([]);
        setDeviceDataExist(false);

      } else {
        protocolList.forEach((item) => {
          actProto.push(item.Id);
        });
        setActiveProto(actProto);
        setCheckProtoValue(true);
      }
    } else {
      let id = value[0].Id;
      if (activeProto.includes(id)) {
        let filterArr = activeProto.filter((val) => val !== id);

        setActiveProto(filterArr);
        if (checkProtoValue) {
          setCheckProtoValue(false);
        }
      } else {
        setActiveProto((prv) => [...prv, id]);
      }
    }
  };

  // complete Protocol Save

  const handleProtocolSave = () => {

    if (!isClientSelected) {
      setSaveError(true); // Set save error if client is not selected
      return;
    }

    // //console.log('Email',email);
    const data = {
      ClientId: clientName.ID,
      PoliceNo: policeno,
      FireNo: fireNo,
      Address: address,
      Email: email,
      MobileNo: mobileno,
    };

    Object.keys(data).forEach(
      (key) =>
      (data[key] =
        typeof data[key] === "string" && data[key].endsWith(",")
          ? data[key].slice(0, -1)
          : data[key])
    );

    //console.log(data)

    setSaveProtocol(data, (response) => {
      if (response.status === 200) {
        ////console.log('Protocol Name:',response);

        setPoliceNo("");
        setMobileNo("");
        setAddress("");
        setFireNo("");
        setEmail("");

        if (clientName.ID !== undefined && clientName.ID !== null) {
          getClientInfo(clientName.ID, (response) => {
            if (response.status === 200) {
              if (response.data !== null) {
                setClientDetails(response.data);
                setShowMessage(true);
                setTimeout(() => {
                  setShowMessage(false);
                }, 3000);
              }
            }
          });
        }
      }
    });
  };

  //Handle Intosion Messages

  const handleIntrusionMessageOneChange = (event) => {
    setMessage1(event.target.value);
  };
  const handleIntrusionMessageTwoChange = (event) => {
    setMessage2(event.target.value);
  };
  const handleIntrusionMessageThreeChange = (event) => {
    setMessage3(event.target.value);
  };

  // Handle protocol message Save
  const handleProtocolMessageSave = () => {
    const deviceIds = selectedCamItems.map((item) => item.deviceid);

    if (activeCameras.length !== 0) {
      ////console.log("Devices",deviceIds);

      // const data = activeCameras.flatMap(DeviceId => {
      //     // const messages = [message1, message2, message3];
      //     // const filteredMessages = messages.filter(message => message !== null);
      //     return {
      //       DeviceId: DeviceId,
      //       IntrusionId: selectedProto.IntrusionId,
      //     };

      //     // return filteredMessages.map((message, index) => ({
      //     //   DeviceId: DeviceId,
      //     //   IntrusionId: selectedProto.IntrusionId,
      //     //   Message: message
      //     // }));
      //   });

      const data = {
        DeviceId: activeCameras.map((item) => `${item}`).join(","),
        IntrusionId: activeProto.join(","),
      };

      //console.log(data)
      addUpdateIntrusion(data, (response) => {
        ////console.log(response)
        if (response.status === 200) {
          setHeader("");
          setErrorCams("Protocols added successfully!");
          setOpenError(true);
          setDeviceDataExist(true);
          HandleProtocolInfo();

          setSelectedProtocol([]);
          setActiveProto([]);
        }
      });
      // setMultiDevicesProtocol(data,(response)=>{
      //   if(response.status === 200){
      //     // need to show alert box

      //     setHeader('')
      //     setErrorCams('Protocols Added Successfully')
      //     setOpenError(true)

      //     HandleProtocolInfo()

      //   }})
    } else {
      const body = {
        IntrusionId: activeProto.join(","),
        Message1: message1,
        Message2: message2,
        Message3: message3,
      };

      if (message1 === null || message1 === "") delete body.Message1;
      if (message2 === null || message2 === "") delete body.Message2;
      if (message3 === null || message3 === "") delete body.Message3;

      if (Object.keys(body).length) {
        setProtocolsInfoMessages(body, (response) => {
          if (response.status === 200) {
            setOpenError(true);
            setHeader("Protocol added successfully!");
            setErrorCams("");
            HandleProtocolInfo();
          }
        });
      }
    }
  };

  const [newText, setNewText] = useState("");


  const [editable, setEditable] = useState({});


  //const [originalData, setOriginalData] = useState({});

  const handleEdit = (row, index, deviceid, intrusionType) => {
    const key = `${deviceid}_${index}_${intrusionType}`;
    const ind = introsionMessages.findIndex((item) => item.Id === row.Id);
    if (ind !== -1) {
      // console.log(introsionMessages[ind])
      setOriginalDataNew(introsionMessages[ind]);
    }

    setEditable((prev) => ({
      ...prev,
      [key]: true,
    }));
  };

  const deleteProtoMessage = () => {
    deleteMessage(protoData, (response) => {
      if (response.status === 200) {
        // rendering
        handleCloseError();
        setprotoData({});
        setShowConfirm(false);
        HandleProtocolInfo();
      }
    });
  };

  const [protoData, setprotoData] = useState({});

  // Define handleRemove function
  const handleRemove = (index, key) => {
    const data = {
      Id: key,
    };
    setprotoData(data);
    setShowConfirm(true);
    setOpenError(true);
    setHeader("Do You Want to Delete Protocol?");
    setErrorCams("");
  };

  const handleSaveData = () => {
    if (removeData) {
      // console.log(removeData)

      const data = removeData[0];
      const key = removeData[2];

      // if(data.hasOwnProperty(key)){
      //   data[key] = "";

      // let body = {DeviceId:row.DeviceId.toString(),IntrusionId:row.IntrusionId}
      //  DeleteDeviceMapping(body,(response)=>{
      //   //console.log(response)
      //   if(response.status === 200){
      //     HandleProtocolInfo()
      //     setRemoveData([])
      //     setDelProto(false)
      //   }
      // })
      // }

      const hasValuesAtIndices = removeData
        .slice(0, 3)
        .every(
          (value) => value !== null && value !== undefined && value !== ""
        );
      if (hasValuesAtIndices) {
        const [row, index, messageId] = removeData;
        handleSave(row, index, messageId, "");
      }
    }
  };

  useEffect(() => {
    // console.log(messageErrors)
  }, [messageErrors]);


  // Define handleSave function
  const handleSave = (row, index, messageId, type, intrusionType) => {
    // setMessageErrors(prev => {
    //   const newErrors = { ...prev };
    //   newErrors[`${row.DeviceId}_${index},${intrusionType}`] = "";
    //   return newErrors;
    // });
    let hasError = false;
    setDelProto(false);
    if (!messageId) {
      let allMessagesContainValues = [];

      if (!row.data) {
        const messageKeys = Object.keys(row).filter((key) =>
          key.startsWith("Message")
        );
        allMessagesContainValues = [
          row.Message1,
          row.Message2,
          row.Message3,
        ].every((msg) => msg !== null && msg.trim() !== "");

        //const keyToCheck =allMessagesContainValues ? messageKeys[index-1] :  messageKeys[index];
        const keyToCheck = messageKeys[index - 1];

        const isNullValue =
          row[keyToCheck] === null ||
          row[keyToCheck] === "" ||
          row[keyToCheck] === "null";
        // console.log(isNullValue)

        if (isNullValue) {
          setMessageErrors((prev) => ({
            ...prev,
            [`${row.DeviceId}_${index}_${intrusionType}`]:
              "This field is required",
          }));
          hasError = true;
        }
      } else {
        if (activeProto.length > 0) {
          // console.log(intrusionType)
          let typeVal = "",
            ix = 0;
          if (!intrusionType) {
            // console.log(activeProto)
            // console.log(protocolList)
            typeVal = protocolList.filter((val) =>
              activeProto.includes(val.Id)
            )[0].IntrusionType;
            const nonEmptyMessageCount = Object.entries(
              introsionMessages[0]
            ).filter(
              ([key, value]) =>
                key.startsWith("Message") && value && value.trim() !== ""
            ).length;
            ix = nonEmptyMessageCount + 1;
          }
          const messageKeys = Object.keys(row.data).filter((key) =>
            key.startsWith("Message")
          );
          const key = messageKeys[row.sno - 1];
          const isNullValue =
            row.data[key] === null ||
            row.data[key] === "" ||
            row.data[key] === "null";
          // console.log(newText)
          if (isNullValue && !newText) {
            setMessageErrors((prev) => ({
              ...prev,
              [`${row.data.DeviceId}_${index}_${typeVal}`]:
                "This field is required",
            }));
            hasError = true;
          }
        }
        // else if(activeProto.length>1){
        //   //console.log(intrus)
        //   const val = groupMessagesByDeviceId(introsionMessages)
        //   console.log(val)
        //   return
        // }
      }
      // if(index >= 0 ){
      //   let allMessagesContainValues =[]

      //   if(!row.data){
      //     allMessagesContainValues = [row.Message1, row.Message2, row.Message3].every(msg => msg !== null && msg.trim() !== "");

      //     const keyToCheck =allMessagesContainValues ? messageKeys[index-1] :  messageKeys[index];
      //     const isNullValue = row[keyToCheck] === null || row[keyToCheck] === "" || row[keyToCheck] === "null";
      //     console.log(isNullValue)

      //     if (isNullValue) {
      //       setMessageErrors(prev => ({
      //         ...prev,
      //         [`${row.DeviceId}_${index}`]: "This field is required"
      //       }));
      //       hasError = true;
      //       // messageKeys.forEach((key, idx) => {
      //       //   if (!row[key] || row[key] === "null") {
      //       //     setMessageErrors(prev => ({
      //       //       ...prev,
      //       //       [`${row.DeviceId}_${index}`]: "This field is required"
      //       //     }));
      //       //     hasError = true;
      //       //   }
      //       // });
      //     }
      //   }
      // }
    }

    if (hasError) {
      // setHeader('')
      // setOpenError(true)
      // setErrorCams('Please add Protocol Messages')
      return;
    }

    let text = "";
    let callRemove = false;
    if (type === "addNew") {
      row = row.data;
      //console.log(row)
      if (key && newText) {
        row[key] = newText;
        setNewText("");
      } else {
        setHeader("Enter Protocol");
        return;
      }
      setNewMessage([]);
    }
    if (messageId) {
      //console.log(row)
      //console.log(row[messageId])
      row[messageId] = "";
      //text = "Protocol Message Removed Successfully!!";
      let MessageCount = Object.keys(row).filter(
        (key) => key.startsWith("Message") && row[key] !== ""
      ).length;
      if (MessageCount === 0) {
        callRemove = true; // to track if all messages are deleted
      }
    } else {
      text = "Protocol updated successfully!";
    }

    if (callRemove) {
      let body = {
        DeviceId: row.DeviceId.toString(),
        IntrusionId: row.IntrusionId,
      };
      DeleteDeviceMapping(body, (response) => {
        //console.log(response)
        if (response.status === 200) {
          HandleProtocolInfo();
          setRemoveData([]);
          setDelProto(false);
        }
      });
    } else {
      let body = {};
      body = {
        IntrusionId: row.IntrusionId,
        DeviceId: row.DeviceId,
        Message1: row.Message1,
        Message2: row.Message2,
        Message3: row.Message3,
        Message4: row.Message4,
        Message5: row.Message5,
      };

      // if(type !== 'addNew'){
      //   body={IntrusionId:row.IntrusionId,DeviceId:row.DeviceId,Message1:row.Message1,Message2:row.Message2,Message3:row.Message3}
      // }
      // else {
      //   body={IntrusionId:row.IntrusionId,DeviceId:row.DeviceId,Message1:row.Message1,Message2:row.Message2,Message3:row.Message3,Message4:row.Message4,Message5:row.Message5}
      // }

      UpdateMessage(body, (response) => {
        //console.log(response)
        if (response.status === 200) {
          setEditable((prev) => ({
            ...prev,
            [`${row.DeviceId}_${index}_${intrusionType}`]: false,
          }));
          if (text) {
            setOpenError(true);
            setHeader(text);
          }
          setErrorCams("");
          HandleProtocolInfo();
          setAddMessage(false);
          setMessageErrors({});
        }
      });
    }
  };

  const [newMessage, setNewMessage] = useState([]);
  const [key, setKey] = useState("");

  const groupMessagesByDeviceId = (messages) => {
    const groupedMessages = {};
    assignedProtocols.forEach(message => {
      if (!groupedMessages[message.DeviceId]) {
        groupedMessages[message.DeviceId] = [];
      }
      groupedMessages[message.DeviceId].push(message);
    });

    console.log('groupMessages:', JSON.stringify(groupedMessages))
    return groupedMessages;
  }

  useEffect(() => {
    // console.log(editable)
  }, [editable]);

  const handleInputChange = (row, value, deviceId, text, messageType) => {
    if (text === "editable") {
      // let updatedIntrosionMessages = [...introsionMessages];
      // updatedIntrosionMessages = updatedIntrosionMessages.filter(item => item.Id === row.Id)
      // updatedIntrosionMessages[0][messageType] = value;

      setIntrosionMessages((prevData) =>
        prevData.map((item) => {
          if (item.Id === row.Id) {
            return {
              ...item,
              [messageType]: value === "" ? "null" : value,
            };
          }
          return item;
        })
      );

      //if (index !== -1) {
      //  const updatedIntrosionMessages = [...introsionMessages];
      //  //console.log(updatedIntrosionMessages[1][messageType])
      // // updatedIntrosionMessages[index][messageType] = value;
      // // setIntrosionMessages(updatedIntrosionMessages);
      //}
    }
  };

  const [lastNumber, setLastNumber] = useState(false);
  const [lastFireNumber, setLastFireNumber] = useState(false);
  const [lastEmail, setLastEmail] = useState(false);
  const [lastContact, setLastContact] = useState(false);
  const [confirmation, setConfirmation] = useState(false);

  const removeNumber = (e, index, type) => {
    e.stopPropagation();
    if (type === "policeNumber") {
      const numbersArray = policeno.split(",");
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(",");
      if (updatedNumbers) {
        setPoliceNo(updatedNumbers);
      } else {
        setPoliceNo("");
        setLastNumber(true);
      }
    } else if (type === "fireNo") {
      const numbersArray = fireNo.split(",");
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(",");
      if (updatedNumbers) setFireNo(updatedNumbers);
      else {
        setFireNo("");
        setLastFireNumber(true);
      }
    } else if (type === "email") {
      const numbersArray = email.split(",");
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(",");
      if (updatedNumbers) {
        setEmail(updatedNumbers);
      } else {
        setEmail("");
        setLastEmail(true);
      }
    } else if (type === "mobile") {
      const numbersArray = mobileno.split(",");
      numbersArray.splice(index, 1);
      const updatedNumbers = numbersArray.join(",");
      if (updatedNumbers) {
        setMobileNo(updatedNumbers);
      } else {
        setMobileNo("");
        setLastContact(true);
      }
    }
  };

  const [addEmptyBox, setEmptyBox] = useState([
    {
      police: false,
      fire: false,
      email: false,
      contact: false,
    },
  ]);

  const handleBoxClick = (val) => {
    // console.log("mobileno",val);

    if (val === "policeno") {
      // console.log("policeNo",policeno);
      if (policeno) {
        setPoliceNo(policeno + ",");
      } else {
        setEmptyBox((prevState) => [
          {
            ...prevState[0],
            police: true,
          },
          ...prevState.slice(1),
        ]);
        if (lastNumber) {
          setLastNumber(false);
        }
      }
    } else if (val === "fireno") {
      //setFireNo(fireNo + ',');
      if (fireNo) {
        setFireNo(fireNo + ",");
      } else {
        setEmptyBox((prevState) => [
          {
            ...prevState[0],
            fire: true,
          },
          ...prevState.slice(1),
        ]);
        if (lastFireNumber) {
          setLastFireNumber(false);
        }
      }
    } else if (val === "email") {
      //setEmail(email + ',')
      if (email) {
        setEmail(email + ",");
      } else {
        setEmptyBox((prevState) => [
          {
            ...prevState[0],
            email: true,
          },
          ...prevState.slice(1),
        ]);
        if (lastEmail) {
          setLastEmail(false);
        }
      }
    } else if (val === "mobileno") {
      // setMobileNo(mobileno + ',')
      if (mobileno) {
        setMobileNo(mobileno + ",");
      } else {
        setEmptyBox((prevState) => [
          {
            ...prevState[0],
            contact: true,
          },
          ...prevState.slice(1),
        ]);
        if (lastContact) {
          setLastContact(false);
        }
      }
    }
  };
  const [newIndex, setNewIndex] = useState(-1);

  const handleNumberChange = (event, index, type) => {
    if (type === "police") {
      const numbersArray = policeno.split(",");
      numbersArray[index] = event.target.value;
      const updatedNumbers = numbersArray.join(",");
      setPoliceNo(updatedNumbers);
    } else if (type === "fire") {
      const numbersArray = fireNo.split(",");
      numbersArray[index] = event.target.value;
      const updatedNumbers = numbersArray.join(",");
      setFireNo(updatedNumbers);
    } else if (type === "email") {
      const numbersArray = email.split(",");
      numbersArray[index] = event.target.value;
      const updatedNumbers = numbersArray.join(",");
      setEmail(updatedNumbers);
    } else if (type === "mobile") {
      const numbersArray = mobileno.split(",");
      numbersArray[index] = event.target.value;
      const updatedNumbers = numbersArray.join(",");
      setMobileNo(updatedNumbers);
    }
  };

  const handleFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);

    // Separate selected and unselected options
    const selectedOptions = filtered.filter((option) =>
      activeCameras.includes(option.deviceid)
    );
    const unselectedOptions = filtered.filter(
      (option) => !activeCameras.includes(option.deviceid)
    );

    // Sort options: selected options first, then unselected
    const sortedOptions = [...selectedOptions, ...unselectedOptions];

    return [{ title: "Select All", selectall: true }, ...filtered];
  };

  const [value, setValue] = useState("two");


  useEffect(() => {
    // //console.log(introsionMessages)
    if (value === "two") {
      setAddProtocol(false);
      setAssignProtocol(true);
      //setIntrosionMessages([])
    }
  }, []);

  const initialProtocolValues = {
    detectionType: '',
    action1: '',
    action2: '',
    action3: '',
    action4: '',
    exception: '',
    comment: ''
  }


  const [formDetails, setFormDetails] = useState(initialProtocolValues);

  const handleCheckboxChange = (event) => {
    setConfirmation(true);
    const escValue = event.target.checked;
    setEscStatus(escValue);
    updateEscalationStatus(escValue)
  };

  const clearValues = () => {
    setFormDetails(initialProtocolValues);
    setErrors({});
  };


  const [errors, setErrors] = useState({});

  const handleFormChange = (event, type) => {
    if (type) {
      setFormDetails((prv) => ({
        ...prv,
        [type]: event.target.value,
      }));

      setErrors((prevErrors) => ({
        ...prevErrors,
        [type]: "",
      }));
    }
  };


  const ProtocolDetails = (id, text) => {
    getProtocolInfoActions(id, (response) => {
      if (response.status === 200) {
        const protocolsData = trimProtocolData(response.data)
        setData(protocolsData)
        if (text === 'updatevalues') {
          setProtocols(protocolsData)
        }
      }
    })
  }


  useEffect(() => {
    ProtocolDetails(0, 'updatevalues');
  }, []);

  const addNewProtocol = () => {
    setErrors({});
    const newErrors = {};

    console.log('formDetails:', JSON.stringify(formDetails));

    Object.keys(formDetails).forEach(key => {
      if (typeof formDetails[key] === 'string' && formDetails[key] !== '') {
        formDetails[key] = formDetails[key].trim();
      }
    });

    // Check if any of the fields are not empty
    const hasAnyValue = Object.values(formDetails).some(
      val => typeof val === "string" && val.trim() !== ""
    );

    if (hasAnyValue) {
      const actionFields = Object.keys(formDetails).filter(key => key.startsWith('action'));
      const actionsFilled = actionFields.some(field => formDetails[field] && formDetails[field].trim() !== '');

      if (actionsFilled && (!formDetails.detectionType || formDetails.detectionType === '')) {
        newErrors['detectionType'] = 'Detection Type is required';
      }


      console.log('data:', JSON.stringify(data));

      if (data.length > 0) {

        const isTypeAvailable = data.filter(item =>
          String(item.DetectionType).trim().toLowerCase() ===
          String(formDetails.detectionType).trim().toLowerCase()
        );

        if (isTypeAvailable.length > 0) {
          newErrors['detectionType'] = `Detection Type already exists`;
        }
      }

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        return;
      }

      const displayname = localStorage.getItem('displayname');
      
      let Location ='';
      const stored = localStorage.getItem('selectedProperty');
      if (stored) {
        const found = properties.find((loc) => loc.ID === parseInt(stored));
        if (found) {
          Location = found.Location;
        }
      }

      console.log('stored:',stored);
      console.log('properties:',properties);

      const body = {
        ClientName: displayname,
        Location: Location,
        DetectionType: formDetails.detectionType,
        Action1: formDetails.action1,
        Action2: formDetails.action2,
        Action3: formDetails.action3,
        Action4: formDetails.action4,
        Exception: formDetails.exception,
        Comment: formDetails.comment,
        EmailType: 'vidisky'
      };

      console.log('body:', JSON.stringify(body));

      addClientProtocolActions(body, (response) => {
        if (response.status === 200) {
          const responseData = response.data;

          console.log('responseData:', JSON.stringify(responseData));
 
          clearValues();

          setAddNewProtocolMessageShow(true);
          setTimeout(() => {
            setAddNewProtocolMessageShow(false);
          }, 5000);
        }
      })
    }

  }


  const [isEdited, setIsEdited] = useState(false);
  const [indexHist, setIndexHist] = useState(null);
  const [delPopUp, setDelPopUp] = useState(false);
  const [delIndex, setDelIndex] = useState(null);

  // const [page, setPage] = useState(0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const handleChangePage = (event, newPage) => {
  //    setPage(newPage);
  //  };

  // const handleChangeRowsPerPage = (event) => {
  //    setRowsPerPage(parseInt(event.target.value, 10));
  //    setPage(0);   };

  // const displayedData = data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleGroupChange = (_, value) => {
    if (value) {
      setActiveCameras([]);
      setActiveProto([]);
      setCheckProtoValue(false);
      // let body = {group_id:value.GroupId,client_id:0}
      // clientGroupInfo(body,(response)=>{
      //   if(response.status === 200){
      //      if(response.data.length>0){
      //       setCheckValue(false)
      //       setCamsList(response.data)
      //      }
      //   }
      // })

      if (groupCamerasInfo.length > 0) {
        let groupDetails = groupCamerasInfo.filter(
          (val) => val.GroupId === value.GroupId
        );
        setCheckValue(false);
        setCamsList(groupDetails);
      }
    } else {
      setCheckValue(false);
      setCamsList([]);
    }
  };


  return (
    <Page title="Protocols">
      <Container maxWidth="xxl" sx={{ p: 0 }}>
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Protocols</Typography>
            <Box sx={{ display: "flex" }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={escStatus}
                    onChange={handleCheckboxChange}
                    sx={{
                      color: theme.palette.primary.main,
                      "&.Mui-checked": { color: theme.palette.primary.main },
                    }}
                  />
                }
                label="Escalation Notification Required"
              />
              <MuiTooltip
                title={
                  <div>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "0.9rem", whiteSpace: "nowrap" }}
                    >
                      <strong>Check:</strong>{" "}
                      <span style={{ color: "green" }}>
                        You will get the escalations
                      </span>
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ fontSize: "0.9rem", whiteSpace: "nowrap" }}
                    >
                      <strong>Uncheck:</strong>{" "}
                      <span style={{ color: "red" }}>
                        Escalation will pause until checked
                      </span>
                    </Typography>
                  </div>
                }
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: (theme) => theme.palette.background.paper,
                      color: theme.palette.text.primary,
                      border: "1px solid grey",
                      boxShadow: 1,
                      padding: "8px",
                      whiteSpace: "normal",
                      maxWidth: "350px",
                      wordBreak: "break-word",
                    },
                  },
                }}
              >
                <Box sx={{ cursor: "pointer", mt: 1 }}>
                  <InfoIcon sx={{ color: "grey" }} />
                </Box>
              </MuiTooltip>
            </Box>
          </Box>
          <Breadcrumbs separator="•" aria-label="breadcrumb">
            <DashboardBreadcrumbLink sx={{ fontSize: '0.875rem' }} />
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>
              Protocols
            </Typography>
          </Breadcrumbs>
        </Box>

        {properties.length > 1 &&
          <Grid container spacing={2} sx={{ mb: 3 }}>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel>Location</InputLabel>
                <Select
                  value={property || ''}
                  label="Location"
                  onChange={(e) => {
                    const val = e.target.value;
                    setProperty(val);
                    localStorage.setItem('selectedProperty', val);
                  }}
                >
                  {properties.map((event) => (
                    <MenuItem key={event.ID} value={event.ID}>
                      {event.Location}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

          </Grid>
        }

        {assignProtocol && (
          <Box>
            {showClientInfo &&
              <Card sx={{ mb: 2 }}>
                <CardContent sx={{ pb: '16px !important' }}>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item sx={{ flexBasis: "20.8333%" }}>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="tags-outlined-client"
                          options={setTypeClient.map((client, clientIndex) => ({
                            ...client,
                            customKey: clientIndex, // Assuming clientIndex is a unique identifier
                          }))}
                          isOptionEqualToValue={(option, value) =>
                            option.customKey === value.customKey
                          }
                          // options={setClient}
                          value={
                            setTypeClient.length === 1
                              ? setTypeClient[0]
                              : clientName
                          }
                          //value={clientName}
                          getOptionLabel={(option) => `${option.displayname}`}
                          //value={clientName}
                          onChange={(e, val) => {
                            handleClient(e, val);
                          }}
                          //value={clientName.ID ? setClient.find((option) => option.ID === clientName.ID) : null}
                          disabled={setTypeClient.length === 1}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Client"
                              placeholder="Search Client Name..."
                              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                              error={saveError && !isClientSelected}
                            />
                          )}
                          renderOption={(props, option) => (
                            <li {...props} key={option.customKey}>
                              {option.displayname}
                            </li>
                          )}
                        />
                        {saveError &&
                          !isClientSelected && ( // Show error message if saveError and !isClientSelected
                            <Typography variant="body2" color="error">
                              Please select a client.
                            </Typography>
                          )}
                      </FormControl>
                    </Grid>
                    {isGroupExist && (
                      <Grid item sx={{ flexBasis: "20.8333%" }}>
                        <FormControl fullWidth>
                          <Autocomplete
                            options={groupList}
                            //value={groupList}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select Group"
                                variant="outlined"
                                placeholder="Search Group..."
                                InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                              />
                            )}
                            freeSolo
                            onChange={handleGroupChange}
                            renderOption={(props, option) => (
                              <li {...props} key={option.GroupId}>
                                {option.GroupName}
                              </li>
                            )}
                            getOptionLabel={(option) => `${option.GroupName}`}
                          />
                        </FormControl>
                      </Grid>
                    )}
                    <Grid item sx={{ flexBasis: "20.8333%" }}>
                      <FormControl fullWidth>
                        <Autocomplete
                          multiple
                          id="tags-outlined-client"
                          options={selectedCamesList}
                          onChange={handleCamera} value={[]}
                          getOptionLabel={(option) =>
                            option.selectall &&
                              selectedCamesList.length === activeCameras.length
                              ? "Select All"
                              : `${option.deviceid} ${option.devicename}`
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Cameras"
                              placeholder="Search Camera Name..."
                              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                            />
                          )}
                          disableCloseOnSelect={openAuto}
                          open={openAuto}
                          onOpen={() => setOpenAuto(true)}
                          onClose={() => setOpenAuto(false)}
                          filterOptions={handleFilterOptions}
                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              {option.selectall ? (
                                <>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    sx={{
                                      color: theme.palette.primary.main,
                                      "&.Mui-checked": { color: theme.palette.primary.main },
                                    }}
                                    style={{ marginRight: 8 }}
                                    checked={checkValue}
                                  //onChange={() => setCheckValue(!checkValue)}
                                  />
                                  {option.title}
                                </>
                              ) : (
                                <>
                                  <Checkbox
                                    icon={icon}
                                    checkedIcon={checkedIcon}
                                    sx={{
                                      color: theme.palette.primary.main,
                                      "&.Mui-checked": { color: theme.palette.primary.main },
                                    }}
                                    style={{ marginRight: 8 }}
                                    checked={activeCameras.includes(
                                      option.deviceid
                                    )}
                                    onChange={() => {
                                      const isChecked = activeCameras.includes(
                                        option.deviceid
                                      );
                                      const newActiveCameras = isChecked
                                        ? activeCameras.filter(
                                          (deviceId) =>
                                            deviceId !== option.deviceid
                                        )
                                        : [...activeCameras, option.deviceid];
                                        console.log('cameras selection4');
                                      setActiveCameras(newActiveCameras);
                                    }}
                                  />
                                  {`${option.devicename}`}
                                </>
                              )}
                            </li>
                          )}
                          //getOptionKey={(option) => option.deviceid}
                          isOptionEqualToValue={(option, value) =>
                            option.deviceid === value.deviceid
                          }
                        />
                      </FormControl>
                    </Grid>
                    <Grid item sx={{ flexBasis: "20.8333%" }}>
                      <FormControl fullWidth>
                        <Autocomplete
                          multiple
                          id="tags-outlined-client"
                          options={selectedCamesList.length > 0 ? protocolList : []}
                          onChange={handleProtocol}
                          value={[]}
                          getOptionLabel={(option) =>
                            option.selectall &&
                              protocolList.length === activeProto.length
                              ? "Select All"
                              : `${option.DetectionType}`
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Protocol"
                              placeholder="Search Protocol Name..."
                              InputLabelProps={{ ...params.InputLabelProps, shrink: true }}
                            />
                          )}
                          disableCloseOnSelect
                          filterOptions={(options, params) => {
                            const filter = createFilterOptions();
                            const filtered = filter(options, params);
                            return [
                              { Id: "select_all", title: "Select All", selectall: true },
                              ...filtered,
                            ];
                          }}


                          renderOption={(props, option, { selected }) => (
                            <li {...props}>
                              {option.selectall ? (
                                <>
                                  <Checkbox
                                    icon={protoIcon}
                                    checkedIcon={protoCheckedIcon}
                                    sx={{
                                      color: theme.palette.primary.main,
                                      "&.Mui-checked": { color: theme.palette.primary.main },
                                    }}
                                    style={{ marginRight: 8 }}
                                    checked={checkProtoValue}
                                  />
                                  {option.title}
                                </>
                              ) : (
                                <>
                                  <Checkbox
                                    icon={protoIcon}
                                    checkedIcon={protoCheckedIcon}
                                    sx={{
                                      color: theme.palette.primary.main,
                                      "&.Mui-checked": { color: theme.palette.primary.main },
                                    }}
                                    style={{ marginRight: 8 }}
                                    checked={activeProto.includes(option.Id)}
                                    onChange={() => {
                                      const isChecked = activeProto.includes(
                                        option.Id
                                      );
                                      const newActiveProtocols = isChecked
                                        ? activeProto.filter(
                                          (val) => val !== option.Id
                                        )
                                        : [...activeProto, option.Id];
                                      setActiveProto(newActiveProtocols);
                                    }}
                                  />
                                  {`${option.DetectionType}`}
                                </>
                              )}
                            </li>
                          )}
                          isOptionEqualToValue={(option, value) =>
                            option.Id === value.Id
                          }
                        />
                      </FormControl>
                    </Grid>
                    {!isProtocolSaveFieldsVisible &&
                      <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <LoadingButton
                          type="submit"
                          onClick={handleProtocolSave}
                          variant="contained"
                        >
                          Save
                        </LoadingButton>
                        {showMessage && (
                          <Typography sx={{ color: theme.palette.success.main }}>
                            Details updated successfully!
                          </Typography>
                        )}
                      </Grid>
                    }
                  </Grid>
                </CardContent>

                <CardContent
                  style={{
                    display: isProtocolSaveFieldsVisible ? undefined : "none",
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item md={3}>
                      <InputLabel shrink>Police Number</InputLabel>
                      <Box
                        sx={{
                          border: `1px solid ${theme.palette.divider}`,
                          padding: "8px",
                          borderRadius: "8px",
                          minHeight:
                            isClientSelected &&
                              clientInfo.length == 1 &&
                              policeno &&
                              !lastNumber
                              ? "auto"
                              : "50px",
                        }}
                        onClick={() => handleBoxClick("policeno")}
                      >
                        {!lastNumber &&
                          isClientSelected &&
                          policeno.split(",").map((policeNumber, index) => (
                            <Box
                              key={index}
                              sx={{
                                marginBottom: 1,
                                width: "80%",
                                backgroundColor: theme.palette.background.neutral,
                                position: "relative",
                                borderRadius: "100px",
                                border: "none",
                                borderColor: "none",
                              }}
                            >
                              <TextField
                                placeholder="Add Police Number"
                                value={policeNumber}
                                onClick={(e) => {
                                  e.stopPropagation();
                                }}
                                onChange={(e) =>
                                  handleNumberChange(e, index, "police")
                                }
                                fullWidth
                                size="small"
                                sx={{
                                  "& input": {
                                    height: "14px",
                                    fontSize: "14px",
                                    color: theme.palette.text.primary,
                                    "&::placeholder": {
                                      color: theme.palette.text.secondary,
                                      opacity: 1,
                                    },
                                  },
                                  "& fieldset": {
                                    //borderRadius: '90px',
                                    border: "none",
                                  },
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  right: "8px",
                                  transform: "translateY(-50%)",
                                  width: "15px",
                                  height: "15px",
                                  borderRadius: "50%",
                                  backgroundColor: theme.palette.background.neutral,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <IconButton
                                  onClick={(e) =>
                                    removeNumber(e, index, "policeNumber")
                                  }
                                >
                                  <CloseIcon
                                    fontSize="small"
                                    style={{ fontSize: "14px", color: theme.palette.text.primary }}
                                  />
                                </IconButton>
                              </Box>
                            </Box>
                          ))}
                      </Box>
                    </Grid>

                    <Grid item md={3}>
                      <InputLabel shrink>Fire Number</InputLabel>
                      <Box
                        sx={{
                          border: `1px solid ${theme.palette.divider}`,
                          padding: "8px",
                          borderRadius: "8px",
                          minHeight:
                            isClientSelected &&
                              clientInfo.length == 1 &&
                              fireNo &&
                              !lastFireNumber
                              ? "auto"
                              : "50px",
                        }}
                        onClick={() => handleBoxClick("fireno")}
                      >
                        {!lastFireNumber &&
                          isClientSelected &&
                          fireNo.split(",").map((fireNo, index) => (
                            <Box
                              key={index}
                              sx={{
                                marginBottom: 1,
                                width: "80%",
                                backgroundColor: theme.palette.background.neutral,
                                borderRadius: "100px",
                                border: "none",
                                position: "relative",
                                borderColor: "none",
                              }}
                            >
                              <TextField
                                placeholder="Add Fire Number"
                                value={fireNo}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) =>
                                  handleNumberChange(e, index, "fire")
                                }
                                fullWidth
                                size="small"
                                sx={{
                                  "& input": {
                                    height: "14px",
                                    fontSize: "14px",
                                    color: theme.palette.text.primary,
                                    "&::placeholder": {
                                      color: theme.palette.text.secondary,
                                      opacity: 1,
                                    },
                                  },
                                  "& fieldset": {
                                    borderRadius: 50,
                                    border: "none",
                                  },
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  right: "8px",
                                  transform: "translateY(-50%)",
                                  width: "15px",
                                  height: "15px",
                                  borderRadius: "50%",
                                  backgroundColor: theme.palette.background.neutral,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <IconButton
                                  sx={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-8px",
                                  }}
                                  onClick={(e) => removeNumber(e, index, "fireNo")}
                                >
                                  <CloseIcon
                                    fontSize="small"
                                    style={{ fontSize: "14px", color: theme.palette.text.primary }}
                                  />
                                </IconButton>
                              </Box>
                            </Box>
                          ))}

                        {/* {!fireNo && isClientSelected && addEmptyBox[0].fire && (
                              <Box
                                sx={{
                                  marginBottom: 1,
                                  width:'80%',
                                  backgroundColor:'#E8E8E8',
                                  position:'relative',
                                  borderRadius: '100px',
                                  border:'none',
                                  borderColor:'none'
                                }}                   
                              >
                                    <TextField
                                      //className={classes.root}
                                      //value={policeNumber}
                                      onClick={(e)=>{
                                        e.stopPropagation()
                                      }}
                                      placeholder='Add Fire Number'
                                      onChange={(e) => {
                                        setFireNo(e.target.value)
                                      }}
                                      fullWidth
                                      size="small"
                                      sx={{
                                        '& input': {
                                          height: '14px',
                                          fontSize: '14px',
                                          "&::placeholder": {
                                            color: theme.palette.text.secondary,
                                            opacity: 1,
                                          },
                                        },
                                        '& fieldset': {
                                          //borderRadius: '90px',
                                          border:'none'
                                        },
                                      }}
                                    />
                                    <Box
                                      sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        right: '8px',
                                        transform: 'translateY(-50%)',
                                        width: '15px',
                                        height: '15px',
                                        borderRadius: '50%',
                                        backgroundColor: theme.palette.action.selected,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center'
                                      }}>
                                      <IconButton
                                        onClick={(e) => removeNumber(e,0,'fireNo')}                            
                                      >
                                      <CloseIcon fontSize="small" style={{ fontSize: '14px', color: theme.palette.text.primary }}/>
                                    </IconButton>
                                  </Box>                   
                              </Box>
                            )} */}
                      </Box>
                    </Grid>

                    <Grid item md={3}>
                      <InputLabel shrink>Email</InputLabel>
                      <Box
                        sx={{
                          border: `1px solid ${theme.palette.divider}`,
                          padding: "8px",
                          borderRadius: "8px",
                          minHeight:
                            isClientSelected &&
                              clientInfo.length == 1 &&
                              email &&
                              !lastEmail
                              ? "auto"
                              : "50px",
                        }}
                        onClick={() => handleBoxClick("email")}
                      >
                        {!lastEmail &&
                          isClientSelected &&
                          email.split(",").map((email, index) => (
                            <Box
                              key={index}
                              sx={{
                                marginBottom: 1,
                                width: "80%",
                                backgroundColor: theme.palette.background.neutral,
                                borderRadius: "100px",
                                position: "relative",
                                border: "none",
                              }}
                            >
                              <TextField
                                placeholder="Add Email"
                                value={email}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) =>
                                  handleNumberChange(e, index, "email")
                                }
                                fullWidth
                                size="small"
                                sx={{
                                  "& input": {
                                    height: "14px",
                                    fontSize: "14px",
                                    color: theme.palette.text.primary,
                                    "&::placeholder": {
                                      color: theme.palette.text.secondary,
                                      opacity: 1,
                                    },
                                  },
                                  "& fieldset": {
                                    borderRadius: 50,
                                    border: "none",
                                  },
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  right: "8px",
                                  transform: "translateY(-50%)",
                                  width: "15px",
                                  height: "15px",
                                  borderRadius: "50%",
                                  backgroundColor: theme.palette.background.neutral,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <IconButton
                                  sx={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-8px",
                                  }}
                                  onClick={(e) => removeNumber(e, index, "email")}
                                >
                                  <CloseIcon
                                    fontSize="small"
                                    style={{ fontSize: "14px", color: theme.palette.text.primary }}
                                  />
                                </IconButton>
                              </Box>
                            </Box>
                          ))}
                      </Box>
                    </Grid>

                    <Grid item md={3}>
                      <InputLabel shrink>Contact Number</InputLabel>
                      <Box
                        sx={{
                          border: `1px solid ${theme.palette.divider}`,
                          padding: "8px",
                          borderRadius: "8px",
                          minHeight:
                            isClientSelected &&
                              clientInfo.length == 1 &&
                              mobileno &&
                              !lastContact
                              ? "auto"
                              : "50px",
                        }}
                        onClick={() => handleBoxClick("mobileno")}
                      >
                        {!lastContact &&
                          isClientSelected &&
                          mobileno.split(",").map((mobile, index) => (
                            <Box
                              key={index}
                              sx={{
                                marginBottom: 1,
                                width: "80%",
                                backgroundColor: theme.palette.background.neutral,
                                borderRadius: "100px",
                                border: "none",
                                position: "relative",
                              }}
                            >
                              <TextField
                                placeholder="Add Contact Number"
                                value={mobile}
                                onClick={(e) => e.stopPropagation()}
                                onChange={(e) =>
                                  handleNumberChange(e, index, "mobile")
                                }
                                fullWidth
                                size="small"
                                sx={{
                                  "& input": {
                                    height: "14px",
                                    fontSize: "14px",
                                    color: theme.palette.text.primary,
                                    "&::placeholder": {
                                      color: theme.palette.text.secondary,
                                      opacity: 1,
                                    },
                                  },
                                  "& fieldset": {
                                    borderRadius: 50,
                                    border: "none",
                                  },
                                }}
                              />
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  right: "8px",
                                  transform: "translateY(-50%)",
                                  width: "15px",
                                  height: "15px",
                                  borderRadius: "50%",
                                  backgroundColor: theme.palette.background.neutral,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <IconButton
                                  sx={{
                                    position: "absolute",
                                    top: "-8px",
                                    right: "-8px",
                                  }}
                                  onClick={(e) => removeNumber(e, index, "mobile")}
                                >
                                  <CloseIcon
                                    fontSize="small"
                                    style={{ fontSize: "14px", color: theme.palette.text.primary }}
                                  />
                                </IconButton>
                              </Box>
                            </Box>
                          ))}
                      </Box>
                    </Grid>

                    <Grid item md={6}>
                      <TextField
                        fullWidth
                        label="Address"
                        placeholder="Enter Address"
                        value={address}
                        onChange={handleAddressChange}
                        InputLabelProps={{ shrink: true }}
                        sx={{
                          "& input": {
                            fontSize: "14px",
                          },
                        }}
                      />
                    </Grid>
                  </Grid>
                  {/* <Grid sx={{marginTop:'1rem'}}>
              
              </Grid> */}
                </CardContent>

                {isProtocolSaveFieldsVisible &&
                  <Box sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", gap: 2, px: 2, pb: 2 }}>
                    {showMessage && (
                      <Typography sx={{ color: theme.palette.success.main }}>
                        Details updated successfully!
                      </Typography>
                    )}
                    <LoadingButton
                      type="submit"
                      onClick={handleProtocolSave}
                      variant="contained"
                    >
                      Save
                    </LoadingButton>
                  </Box>
                }
              </Card>
            }

            <Card sx={{ my: 2 }}>
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item sx={{ flexBasis: "20.8333%" }}>
                    <TextField
                      label='Detection Type'
                      placeholder='Enter Detection Type'
                      InputLabelProps={{ shrink: true }}
                      value={formDetails.detectionType}
                      onChange={(e) => handleFormChange(e, 'detectionType')}
                      error={!!errors.detectionType}
                      helperText={errors.detectionType}
                      autoComplete="off"
                      size="small"
                      fullWidth
                    />
                  </Grid>
                  {[1, 2, 3, 4].map((num) => (
                    <Grid item sx={{ flexBasis: "20.8333%" }} key={`action${num}`}>
                      <TextField
                        label={`Action ${num}`}
                        placeholder={`Enter Action ${num}`}
                        InputLabelProps={{ shrink: true }}
                        value={formDetails[`action${num}`] || ''}
                        onChange={(e) => handleFormChange(e, `action${num}`)}
                        error={!!errors[`action${num}`]}
                        helperText={errors[`action${num}`]}
                        autoComplete="off"
                        size="small"
                        fullWidth
                      />
                    </Grid>
                  ))}

                  <Grid item sx={{ flexBasis: "20.8333%" }}>
                    <TextField
                      label='Exception'
                      placeholder='Enter Exception'
                      InputLabelProps={{ shrink: true }}
                      value={formDetails.exception}
                      onChange={(e) => handleFormChange(e, 'exception')}
                      error={!!errors.exception}
                      helperText={errors.exception}
                      autoComplete="off"
                      size="small"
                      fullWidth
                    />
                  </Grid>

                  <Grid item sx={{ flexBasis: "20.8333%" }}>
                    <TextField
                      label='Comments'
                      placeholder='Enter Comments'
                      InputLabelProps={{ shrink: true }}
                      value={formDetails.comment}
                      onChange={(e) => handleFormChange(e, 'comment')}
                      error={!!errors.comment}
                      helperText={errors.comment}
                      autoComplete="off"
                      size="small"
                      fullWidth
                    />
                  </Grid>

                  <Grid item>
                    <Button variant='contained' onClick={addNewProtocol} disabled={addNewProtocolMessageShow}>Send Request</Button>
                  </Grid>

                  <Grid item>
                    <Button color="error" variant="contained" onClick={clearValues}>Clear</Button>
                  </Grid>

                  {addNewProtocolMessageShow && 
                    (
                      <Typography variant="h6" sx={{ color: theme.palette.success.main }} mt={2} ml={2} mb={0}>
                        Request submitted successfully! Our team will review your protocol and get back to you within 48 hours.
                      </Typography>
                    )
                  }
                </Grid>
              </CardContent>
            </Card>

            <Card>
              <CardContent sx={{ pb: '16px !important' }}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  mb={2}
                >
                  <Typography variant="h4" gutterBottom>
                    Protocols
                  </Typography>
                </Stack>

                {deviceDataExist && activeCameras.length !== 0 ? (
                  Object.entries(groupMessagesByDeviceId(assignedProtocols)).map(([DeviceId, messagesForDevice]) => {
                    return (
                      <Card key={`device-${DeviceId}`} sx={{ mb: 2 }}>
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          sx={{ px: 2, pt: 1.5, pb: 0.5 }}
                        >
                          {messagesForDevice[0]['devicename']}
                        </Typography>
                        <CardContent sx={{ padding: '0px', '&:last-child': { paddingBottom: 0 } }}>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 800, maxHeight: 400 }}>
                              <Table stickyHeader>
                                <TableHead>
                                  <TableRow sx={{ backgroundColor: theme.palette.background.neutral }}>
                                    <TableCell align="center">S.No</TableCell>
                                    <TableCell align="center">Detection Type</TableCell>
                                    <TableCell align="center">Steps</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {messagesForDevice.length > 0 ? (
                                    messagesForDevice.map((item, index) => {
                                      const itemId = item.Id || `row-${index}`;
                                      return (
                                        <TableRow key={itemId}>
                                          <TableCell align="center">{index + 1}</TableCell>
                                          <TableCell align="center">{item.DetectionType}</TableCell>
                                          <TableCell
                                            align="left"
                                            sx={{ width: '500px', overflow: 'hidden', wordWrap: 'break-word', whiteSpace: 'normal' }}
                                          >
                                            <Box display="flex" flexDirection="column" gap={1}>
                                              {[1, 2, 3, 4].map((actionNum) => {
                                                const field = `Action${actionNum}`;
                                                return (
                                                  item[field] && (
                                                    <span key={`${itemId}-action-${actionNum}`}>
                                                      <span style={{ color: theme.palette.primary.main, paddingRight: '5px' }}>
                                                        {`Action ${actionNum}:`}
                                                      </span>
                                                      {item[field]}
                                                    </span>
                                                  )
                                                );
                                              })}
                                            </Box>

                                            {item['Exception'] && (
                                              <Box
                                                key={`${itemId}-exception`}
                                                display="flex"
                                                flexDirection="column"
                                                gap={1}
                                                sx={{ mt: '10px' }}
                                              >
                                                <span>
                                                  <span style={{ color: theme.palette.primary.main, paddingRight: '5px' }}>Exception:</span>
                                                  {item['Exception']}
                                                </span>
                                              </Box>
                                            )}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })
                                  ) : (
                                    <TableRow>
                                      <TableCell colSpan={6} style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                        No Data
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                        </CardContent>
                      </Card>
                    );
                  })
                ) : null}
                
                {/* Show error message only when conditions are not met AND showProtocolsError is true */}
                {!(deviceDataExist && activeCameras.length !== 0) && showProtocolsError && (
                  <span
                    style={{
                      fontSize: '1.25rem',
                      color: theme.palette.text.primary,
                      display: 'block',
                      fontWeight: 'bold',
                      textAlign: 'center',
                      paddingBottom: '10px'
                    }}
                  >
                    No Protocols Exists
                  </span>
                )}

              </CardContent>
            </Card>
          </Box>
        )}
        <Dialog
          open={openError}
          onClose={handleCloseError}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>{header}</DialogTitle>
          <DialogContent>
            <Typography variant="h6">{errorCams}</Typography>
          </DialogContent>
          <DialogActions>
            {showConfirm && (
              <Button variant="contained" onClick={deleteProtoMessage} sx={{
                color: theme.palette.primary.contrastText,
                '&:hover': {
                  color: theme.palette.primary.contrastText,
                }
              }}>
                Ok
              </Button>
            )}
            <Button onClick={handleCloseError} variant="contained" sx={{
              color: theme.palette.primary.contrastText,
              '&:hover': {
                color: theme.palette.primary.contrastText,
              }
            }}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page>
  );
};

export default ProtocolIndividualAll;
